import clsx from 'clsx';
import { Badge } from '../../../catalyst/badge';

/**
 * Shared crossed-out treatment for extraction-table cells (DR-2299): the primary
 * text struck through with `line-through` when the extractor flagged the row
 * `crossedOut`, plus a "Crossed out" badge stacked underneath.
 *
 * Two call sites: the AD table's AD-number cell (plain span) and the QEC table's
 * description cell (`truncate` — `block truncate` so a long description clips to
 * the cell width; the surrounding `TruncatedContentTd` carries the hover `title`).
 * Renders a fragment so it drops straight into each table's existing cell wrapper.
 */
export function CrossedOutCell({
  text,
  crossedOut,
  truncate = false,
}: {
  text: React.ReactNode;
  crossedOut: boolean | undefined;
  truncate?: boolean;
}) {
  return (
    <>
      <span className={clsx(truncate && 'block truncate', crossedOut && 'line-through')}>{text}</span>
      {crossedOut && (
        <div className="mt-1">
          <Badge color="zinc">Crossed out</Badge>
        </div>
      )}
    </>
  );
}
